import { render, staticRenderFns } from "./SubscriptionAdd.vue?vue&type=template&id=b50e078a"
import script from "./SubscriptionAdd.vue?vue&type=script&lang=js"
export * from "./SubscriptionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports